// extracted by mini-css-extract-plugin
export default {"addButton":"AmVqrU67uG00b4k7MYEw"};